import { PropsWithChildren, useState } from 'react';
import { cn } from '@sandtech-hub-monorepo/ui-kit';
import { ChevronDownIcon, CircleCheckIcon, ClipboardListIcon } from 'lucide-react';

interface Props extends PropsWithChildren {
  name: string;
  initialExpanded: boolean;
  isLastElement?: boolean;
  totalCredits?: number;
  isCompleted?: boolean;
}

export const CoursesGroupView = ({
  name,
  initialExpanded,
  isLastElement,
  totalCredits,
  isCompleted,
  children,
}: Props) => {
  const [expanded, setExpanded] = useState(initialExpanded);

  return (
    <>
      <div
        onClick={() => setExpanded(!expanded)}
        className={cn(
          'flex justify-between items-center py-5 pl-3 pr-5 bg-background-quaternary border-b-background-secondary text-heading font-semibold text-base select-none cursor-pointer',
          !isLastElement && 'border-b'
        )}
      >
        <div className="flex items-center gap-3">
          {name}
          {/* {totalCredits !== undefined && totalCredits > 0 && (
            <span className="flex items-center gap-1.5 font-normal text-sm text-muted-foreground">
              <ClipboardListIcon size={14} />
              Credit hours: {totalCredits}
            </span>
          )} */}
          {isCompleted && (
            <CircleCheckIcon size={20} className="text-success" />
          )}
        </div>
        <ChevronDownIcon
          width={24}
          height={24}
          className={cn(
            'transition-transform',
            expanded ? 'rotate-180' : 'rotate-0'
          )}
        />
      </div>
      <div
        className={cn(
          'grid transition-[grid-template-rows,_opacity] duration-300',
          expanded ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'
        )}
      >
        <div className="overflow-hidden">{children}</div>
      </div>
    </>
  );
};
